import { Grid, Row, Col, Avatar } from "antd";
// import useUser from '../../hooks/useUser';
import { useUser } from '../../hooks/UserProvider'

const Header = () => {
    const { userData } = useUser();


    const now = new Date();
    const hour = now.getHours();

    let greeting = "Good morning";

    if (hour >= 12 && hour < 17) {
        greeting = "Good afternoon";
    } else if (hour >= 17 || hour < 5) {
        greeting = "Good evening";
    }

    return(
        <>
            <Row>
                <Col span={24}>
                <div className="userDetails">
                    {/* {userData?.image ? (
                        <Avatar
                            size={64}
                            src={userData.image}
                        />
                    ) : (
                    )} */}
                        <i className="fa-regular fa-circle-user"></i>
                    <div className="name-greetings">
                        <p className="name">Hi {userData?.first_name},</p>
                        <p className="greetings">{greeting}</p>
                    </div>
                </div>
                </Col>
            </Row>
        </>
    )
}

export default Header;